import { render } from "./articleListe.vue?vue&type=template&id=1c0a731a&scoped=true"
import script from "./articleListe.vue?vue&type=script&lang=js"
export * from "./articleListe.vue?vue&type=script&lang=js"

import "./articleListe.vue?vue&type=style&index=0&id=1c0a731a&lang=scss&scoped=true"

import exportComponent from "/usr/src/test-oho-sales/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c0a731a"]])

export default __exports__